var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('HeadTop',{staticClass:"boxTop"}),(_vm.showRouterView)?_c('router-view',{staticStyle:{"margin-top":"180px"}}):_vm._e(),_c('FootBox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }